export class HandleShape {

    constructor(canvas, options) {

        this._canvas = canvas;

        this._x = options.x || 0;
        this._y = options.y || 0;
        this._onDrag = options.onDrag || function() {};
        this._onDragStart = options.onDragStart || function() {};
        this._onDragEnd = options.onDragEnd || function() {};

        this._shape = this._canvas.circle(this._x, this._y, 10);

        this._shape.attr({
            class: 'handle',
            strokeWidth: '2'
        });

        this._shape.mousedown((e) => {
            e.stopPropagation();
        });


        this._shape.drag(this.onDrag, this.onDragStart, this.onDragEnd, this, this, this);

        this.hide();

    }

    onDrag(dx, dy) {
        this.setPosition({x: this._tempX + dx, y: this._tempY + dy});
        this._onDrag(this);
    }

    onDragStart() {
        this._tempX = this._x;
        this._tempY = this._y;

        this._onDragStart(this);
    }

    onDragEnd() {
        this._onDragEnd(this);
    }

    remove() {
        this._shape.remove();
    }

    setPosition(val) {

        this._x = val.x;
        this._y = val.y;

        this._shape.attr({
            cx: this._x,
            cy: this._y
        });

    }

    getPosition() {
        return {
            x: this._x,
            y: this._y
        }
    }

    show() {
        this._shape.attr({
            display: ''
        });
    }

    hide() {
        this._shape.attr({
            display: 'none'
        });
    }

}



// WEBPACK FOOTER //
// ./src/js/components/design-preview/handle-shape.js